var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "progress-66-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.2897C0 8.29818 2.42513 5.87305 5.41667 5.87305H20.5833C23.5749 5.87305 26 8.29818 26 11.2897V15.623C26 18.6146 23.5749 21.0397 20.5833 21.0397H5.41667C2.42513 21.0397 0 18.6146 0 15.623V11.2897ZM5.41667 8.03971C3.62175 8.03971 2.16667 9.49479 2.16667 11.2897V15.623C2.16667 17.418 3.62175 18.873 5.41667 18.873H20.5833C22.3783 18.873 23.8333 17.418 23.8333 15.623V11.2897C23.8333 9.49479 22.3783 8.03971 20.5833 8.03971H5.41667ZM10.8333 12.373C10.8333 11.1764 11.8034 10.2064 13 10.2064C14.1967 10.2064 15.1667 11.1764 15.1667 12.373V14.5397C15.1667 15.7364 14.1967 16.7064 13 16.7064C11.8034 16.7064 10.8333 15.7364 10.8333 14.5397V12.373ZM6.5 10.2064C5.30338 10.2064 4.33333 11.1764 4.33333 12.373V14.5397C4.33333 15.7364 5.30338 16.7064 6.5 16.7064C7.69662 16.7064 8.66667 15.7364 8.66667 14.5397V12.373C8.66667 11.1764 7.69662 10.2064 6.5 10.2064Z",
    fill: "#43B5F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgress);
export default __webpack_public_path__ + "static/media/icon_progress.1051d8003abb469eb55912ad33fdf0d4.svg";
export { ForwardRef as ReactComponent };